export class VehicleVersionQuotes {
  theoreticalKilometers: number;
  sellVehicleQuote: number;
  newPriceList: number;
}
